import { render, staticRenderFns } from "./emergencyDetails.vue?vue&type=template&id=62f52039"
import script from "./emergencyDetails.vue?vue&type=script&lang=js"
export * from "./emergencyDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports